<template>
  <div>
    <!--面包屑-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/Home' }">首页 </el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>前台用户</el-breadcrumb-item>
    </el-breadcrumb>

    <!--卡片区域-->
    <el-card class="box-card">
      <div>
        <el-row :gutter="20" type="flex" align="top">
          <el-col :span="8">
            <el-form :inline="true">
              <el-form-item label="关键词搜索">
                <el-input
                  clearable
                  placeholder="搜索用户信息"
                  v-model="searchKey"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="2">
            <el-button size="mini" round type="success" @click="getList"
              >搜索</el-button
            >
          </el-col>
          <el-col :span="4">
            <el-button size="mini" round type="warning" @click="onAdd"
              >新增</el-button
            >
          </el-col>
        </el-row>

        <!--用户列表区-->
        <div class="table">
          <el-table
            :data="tableData"
            :border="true"
            :height="getH()"
            stripe
            :resizable="true"
          >
            <el-table-column
              show-overflow-tooltip
              v-for="(item, index) in propList"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width ? item.width : 80"
            >
              <!--显示特殊字段-->
              <template slot-scope="scope">
                <div v-if="item.type == 'array'">
                  {{ getOptionVal(item.data, scope.row[item.prop]) }}
                </div>
                <!--显示用户头像-->
                <img
                  v-else-if="
                    scope.column['property'] == 'head_img' &&
                    scope.row['head_img_val']
                  "
                  :src="scope.row['head_img_val']"
                  width="50"
                  height="50"
                />
                <!--显示用户一寸照片-->
                <img
                  v-else-if="
                    scope.column['property'] == 'user_img' &&
                    scope.row['user_img_val']
                  "
                  :src="scope.row['user_img_val']"
                  width="50"
                  height="50"
                />
                <!--显示其它赋值-->
                <div v-else>
                  {{ scope.row[scope.column["property"]] }}
                </div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <div class="caoz">
                  <el-button type="text" size="small" @click="onEdit(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="remvRoleById(scope.row)"
                  >
                    删除</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="resetPwd(scope.row)"
                  >
                    重置密码</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!--分页区-->
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>

    <!--编辑描述窗口-->
    <el-dialog
      v-if="showEditDlg"
      :close-on-click-modal="false"
      :title="!editItem.uid ? '新增' : '编辑'"
      :visible.sync="showEditDlg"
      width="300"
      :before-close="handleCloseDlg"
    >
      <el-form :inline="false" label-width="150px">
        <el-row>
          <el-col
            class="myElCol"
            :span="11"
            v-for="(item, index) in propList"
            :key="index"
          >
            <el-form-item :label="item.label">
              <el-select
                v-if="item.type == 'array'"
                v-model="editItem[item.prop]"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item2, index2) in item.data"
                  :key="index2"
                  :label="item2"
                  :value="index2"
                >
                </el-option>
              </el-select>
              <el-date-picker
                v-else-if="item.type == 'time'"
                v-model="editItem[item.prop]"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
              >
              </el-date-picker>
              <el-input
                v-else
                :type="item.type == 'textarea' ? 'textarea' : 'text'"
                :disabled="item.prop == 'uid'"
                :rows="2"
                clearable
                v-model="editItem[item.prop]"
              >
              </el-input>
              <MyUploadPlus
                v-if="item.prop == 'head_img' || item.prop == 'user_img'"
                accept="*"
                :disabled="false"
                @urlChange="(e) => onUrlChange(item.prop, e)"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditDlg = false">取 消</el-button>
        <el-button type="primary" @click="onSaveEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
export default {
  data() {
    return {
      //获取用户参数列表对象
      queryInfo: {
        query: "",
        //当前的页数
        pageNum: 1,
        //当前的页码显示的条数
        pageSize: 10,
      },

      //用户数据列表 默认为空
      tableData: [],
      //总数据条数
      total: 0,
      //显示积分
      boolArr: ["否", "是"],
      has_alias: "",
      is_alias: 0,
      //开关

      searchKey: "",
      uid: "",
      //prop="username" label="姓名"
      propList: [
        {
          prop: "uid",
          label: "用户ID",
        },

        {
          prop: "add_time",
          label: "添加时间",
          width: 200,
          type: "time",
        },
        {
          prop: "user_name",
          label: "登录账号",
          width: 200,
        },
        /*
       {
          prop: "user_pwd",
          label: "用户密码",
          width: 150,
        },
        */
        {
          prop: "wx_nick",
          label: "微信昵称",
          width: 150,
        },
        {
          prop: "phone",
          label: "手机号",
          width: 150,
        },

        {
          prop: "head_img",
          label: "用户头像",
          type: "textarea",
          width: 200,
        },
        {
          prop: "user_card",
          label: "身份证号",
          width: 200,
        },
        {
          prop: "is_lock",
          label: "是否禁用",
          width: 120,
          type: "array",
          data: ["否", "是"],
        },
        {
          prop: "last_login",
          label: "最后登录",
          width: 160,
        },
        {
          prop: "is_member",
          label: "是否为会员",
          width: 120,
          type: "array",
          data: ["否", "是"],
        },

        {
          prop: "jifen",
          label: "当前积分",
        },
        {
          prop: "real_name",
          label: "真实姓名",
        },
        {
          prop: "company_name",
          label: "单位名称",
          width: 150,
        },
        {
          prop: "special",
          label: "专业名称",
          width: 150,
        },

        {
          prop: "user_img",
          label: "用户一寸照片",
          width: 150,
        },
        {
          prop: "user_job",
          label: "用户职位",
          width: 150,
        },
        {
          prop: "bz",
          label: "备注",
        },
      ],
      /**
       `tui_userid` int(11) NOT NULL DEFAULT '0' COMMENT '推广用户ID',
  `my_renid` int(11) NOT NULL DEFAULT '0' COMMENT '我的人才ID',
  `h5data` varchar(255) NOT NULL DEFAULT '' COMMENT 'app数据',
  `is_alias` int(11) NOT NULL DEFAULT '0' COMMENT '是否为小号',
  `has_alias` int(11) NOT NULL DEFAULT '0' COMMENT '有小号功能',
  `zhu_uid` int(11) NOT NULL DEFAULT '0' COMMENT '主号ID',
  `show_location` int(11) NOT NULL DEFAULT '0' COMMENT '显示地址',
  `close_info` int(11) NOT NULL DEFAULT '0' COMMENT '关闭信息',
       */
      //控制编辑对话框的显示与隐藏
      showEditDlg: false,
      //控制编辑对话框的对相
      editItem: "",
      radio: "1",
    };
  },
  created() {
    //窗体大小变化就执行getH方法
    window.addEventListener("resize", this.getH);
    this.getList();
  },

  methods: {
    //调整table 高度
    getH() {
      return window.innerHeight - 330;
    },
    //获取用户参数列表
    async getList() {
      let obj = {
        page: this.queryInfo.pageNum,
        pageSize: this.queryInfo.pageSize,
        searchKey: this.searchKey,
        uid: this.uid,
      };
      const res = await this.$post(`User/getList`, obj);
      console.log("kkk", res);
      if (res.code !== 200) return;

      this.tableData = res.data.data;
      //获取特殊字段值
      for (let i in this.tableData) {
        //显示用户头像
        if (this.tableData[i]["head_img"].length > 0) {
          this.tableData[i]["head_img_val"] = this.$getUrl(
            this.tableData[i]["head_img"]
          );
        }
        //显示用户一寸照片
        if (this.tableData[i]["user_img"].length > 0) {
          this.tableData[i]["user_img_val"] = this.$getUrl(
            this.tableData[i]["user_img"]
          );
        }
      }
      // console.log(this.tableData,res.data.data)
      this.total = res.data.total;
    },

    //监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      //console.log(newSize)
      this.queryInfo.pageSize = newSize;
      this.getList();
    },

    //监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      //console.log(newPage)
      this.queryInfo.pageNum = newPage;
      //获取用户列表数据
      this.getList();
    },
    //
    handleClick(row) {
      console.log(row);
    },
    //点击搜索显示搜索内容
    onSubmit() {
      this.getList();
    },
    // 展示编辑角色对话框 Dialog:对话框
    onEdit(item) {
      this.editItem = JSON.parse(JSON.stringify(item));
      this.showEditDlg = true;
    },
    onAdd() {
      console.log("onAdd");
      let obj = {};
      for (let i in this.propList) {
        let prop = this.propList[i]["prop"];
        this.$set(obj, prop, "");
      }
      this.editItem = obj;
      this.showEditDlg = true;
    },
    editRoleDialogClosed() {},
    //点击确定保存修改用户信息
    async onSaveEdit() {
      this.showEditDlg = false;
      let Obj1 = {
        editUid: this.editItem.uid,
        data: {
          ...this.editItem,
        },
      };
      const res = await this.$post(`User/saveData`, Obj1);
      console.log(res);

      if (res.code !== 200) return;
      this.$ok(res.msg);
      this.getList();
    },
    //点击删除弹出对话框是否真的删除
    async remvRoleById(item) {
      //弹出对话框是否真的删除 此操作将永久删除该用户信息
      const confirmResult = await this.$confirm(
        "此操作将永久删除该用户信息?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      //如果用户确认删除,则返回值为字符串  confirm
      //如果用户取消删除,则返回值为字符串  cancel
      //console.log( confirmResult );
      if (confirmResult !== "confirm") {
        return this.$message.info("已取消删除");
      }
      let obj2 = {
        uid: item.uid,
      };
      console.log(obj2);
      const res = await this.$post(`User/delItem`, obj2);
      console.log("确认删除", res);
      if (res.code !== 200) return;
      this.$ok(res.msg);
      this.getList();
    },
    handleCloseDlg() {
      console.log("handleCloseDlg");
      this.showEditDlg = false;
    },
    async resetPwd(item) {
      let obj = await this.$prompt("请输入新密码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /.{6,15}/,
        inputErrorMessage: "密码长度需6-15",
      }).catch(() => {
        this.$info({
          type: "info",
          message: "取消输入",
        });
        return;
      });
      console.log("obj", obj);
      if (!obj || obj.length < 1) {
        return;
      }
      let pwd = obj.value;
      const confirmResult = await this.$confirm(
        "确认密码重置为: " + pwd + " 吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);

      if (confirmResult !== "confirm") {
        return;
      }

      //提交
      this.callRetSetPwd(item, pwd);
    },
    //提交密码
    async callRetSetPwd(item = null, pwd = "") {
      console.log("pwd", pwd);
      let obj = {
        editUid: item.uid,
        user_name: item.user_name,
        user_pwd: pwd,
      };
      const res = await this.$post(`User/forget`, obj);
      console.log("提交密码", res);
      if (res.code !== 200) return;
      this.$ok(res.msg);
    },
    onUrlChange(fielddName, e) {
      console.log("获取 getUrlChange", fielddName, e);
      this.editItem[fielddName] = e[0].url;
    },
  },
};
</script>


<style lang="less">
/deep/ .el-table {
  .el-table-body {
    height: 100%;
    margin-top: 5px !important;
  }
}

.el-breadcrumb {
  font-size: 16px !important;
  margin: 0 !important;
}
</style>
<style lang="less" scoped>
.mybtn {
  display: flex;
  justify-content: flex-end;
}

.jifen {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
